import { render, staticRenderFns } from "./CenterColumn.vue?vue&type=template&id=bf2d8a12&scoped=true"
import script from "./CenterColumn.vue?vue&type=script&lang=js"
export * from "./CenterColumn.vue?vue&type=script&lang=js"
import style0 from "./CenterColumn.vue?vue&type=style&index=0&id=bf2d8a12&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf2d8a12",
  null
  
)

export default component.exports